export default __webpack_public_path__ + "882cfd2b167e2f96423743ff000b814b.png";